import { useCallback } from 'react'

import { RefetchQueriesFunction } from '@apollo/react-common'
import { ApolloQueryResult } from 'apollo-boost'

import { logger } from '@app/common/logger/logger'
import { useDeleteMessageAsLawyerMutation } from '@app/queries/DeleteMessageAsLawyer/DeleteMessageAsLawyer.queries'

export type Args = {
  refetchMessages: () => Promise<ApolloQueryResult<any>>
  refetchLetter: RefetchQueriesFunction
}

export const useDeleteLawyerMessage = ({ refetchMessages, refetchLetter }: Args) => {
  const [deleteMessageAsLawyerMutation, { loading, error }] = useDeleteMessageAsLawyerMutation()

  const deleteMessage = useCallback(async (messageId) => {
    try {
      await deleteMessageAsLawyerMutation({
        refetchQueries: refetchLetter,
        variables: {
          messageId
        }
      })
      await refetchMessages()
    } catch (e) {
      logger.error(e)
    }
  }, [])

  return { deleteMessage, deleteMessageLoading: loading, deleteMessageError: error }
}
